import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';
import { type Board } from '@air/api/types';

import META from '~/hooks/events/useTrackViewedBoard.meta';

export type TrackViewedBoardParams = {
  board_id: Board['id'];
};

export const useTrackViewedBoard = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedBoard = useCallback(
    (params: TrackViewedBoardParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackViewedBoard };
};
